export enum NotificationType {
  success,
  error,
  info,
  warning
}

export class Notification {
  id?: number;
  title: string = '';
  text: string = '';
  style?: NotificationType;
  constructor(data?: Notification) {
      this.id = data?.id;
      this.title = data?.title ?? '';
      this.text = data?.text ?? '';
      this.style = data?.style;
  }
}
